import { Language } from './base';

const pdash = () => import('../translations/pdash/he-IL.json');
const webActivities = () => import('../translations/web-activities/he-IL.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/he-IL.json');

export default new Language({
    code: 'he-IL',
    locale: 'he',
    localName: 'עברית',
    englishName: 'Hebrew',
    territory: 'IL',
    timezones: ['Asia/Jerusalem'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
